var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(!_vm.disabled)?_c('router-link',{attrs:{"to":'/' +
            _vm.$i18n.locale +
            '/' +
            (_vm.to.startsWith('/') ? _vm.to.substring(1) : _vm.to)}},[_vm._t("default")],2):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }